import spiderman from '@/spiderman/index';

const { axios, api } = spiderman;

async function getSchedule(member) {
  return (
    await axios.get(api.schedules, {
      headers: {
        jwt: member.jwt,
      },
      params: {
        clinic: member.info.clinic,
      },
    })
  ).data;
}

async function make(member, memberInfo, appointmentInfo) {
  return (
    await axios.post(
      api.appointments,
      {
        clinic: member.info.clinic,

        id: memberInfo.id,
        name: memberInfo.name,
        birthdate: memberInfo.birthdate,
        mobile: memberInfo.mobile,

        date: appointmentInfo.date,
        shiftId: appointmentInfo.shiftId,
        timeSlotName: appointmentInfo.timeSlotName,
        doctor: appointmentInfo.doctor,
        division: appointmentInfo.division,
      },
      {
        headers: {
          jwt: member.jwt,
        },
      },
    )
  ).data;
}

async function query(member, {
  id,
  birthdate,
}) {
  return (
    await axios.get(api.appointments, {
      headers: {
        jwt: member.jwt,
      },
      params: {
        clinic: member.info.clinic,

        id,
        birthdate,
      },
    })
  ).data;
}

async function cancel(member, memberInfo, appointmentInfo) {
  await axios.delete(api.appointments, {
    headers: {
      jwt: member.jwt,
    },
    params: {
      clinic: member.info.clinic,

      id: memberInfo.id,

      appointmentId: appointmentInfo.appointmentId,
    },
  });
}

export default {
  getSchedule,
  make,
  query,
  cancel,
};
